import Divider from "../../../../../src/components/divider/Divider";
import { Playground, Props } from 'docz';
import * as React from 'react';
export default {
  Divider,
  Playground,
  Props,
  React
};